<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
    <div class="d-flex flex-row justify-content-between ">
        <div class="d-flex flex-row" style="align-items: self-end;width: 50%;">
            <img class="menager_picture"
                [src]="!companyModel.generalManagerProfileImageUrl ? imagePath :companyModel.generalManagerProfileImageUrl "
                alt="profile-picture">
                <div class="menager_name">
                    <label class="w-100">{{companyModel.generalManagerName }} </label>
                    <label class="w-100 h6">{{companyModel.generalManagerRoleName }} </label>
                </div>
              
        </div>
    </div>
    <div class="pt-2 pb-4 lh-1">
        <label class="user_name"><i *ngIf="!companyModel.active" class="pi pi-ban user_susp"></i>{{
            companyModel.companyName }} </label>
        <label class="user_location">{{ companyModel.city }}, {{ companyModel.countryCode }}</label>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'Address' | translate }}<i
                    class="pi pi-map-marker h6 m-0 float-end"></i></label>
            <label class="input_text_field">{{ companyModel.address }}</label>
        </div>
        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'Phone' | translate }}<i
                    class="pi pi-phone h6 m-0 float-end"></i></label>
            <label class="input_text_field">{{ companyModel.phone }}</label>
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'Tax number' | translate }}<i
                    class="pi pi-check h6 m-0 float-end"></i></label>
            <label class="input_text_field">{{ companyModel.taxNumber }}</label>
        </div>
        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'Email' | translate }}<i
                    class="pi pi-envelope h6 m-0 float-end"></i></label>
            <label class="input_text_field">{{ companyModel.email }}</label>
        </div>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'Venues' | translate }}<i
                    class="pi  h6 m-0 float-end"><span class="spam_white p-0">{{companyModel.numberOfVenues}}</span></i></label>

        </div>
        <div style="width: 100%; ">
            <label style="margin-top: 0px;" class="user_label">{{ 'Events' | translate }}<i
                    class="pi h6 m-0 float-end"><span class="spam_white p-0">{{companyModel.numberOfEvents}}</span></i></label>

        </div>
    </div>
</div>
<p-toast position="top-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>